import { ROUTE_B2C_EA, ROUTE_B2B_EA } from '../routing/paths';

export const redirectToB2C = (): void => {
    let redirectUrl = `${window.location.origin}${ROUTE_B2C_EA}`;
    // le B2C n'utilise pas vite, donc pas de double prefix !
    window.location.href = redirectUrl;
};
export const redirectToB2B = (): void => {
    let redirectUrl = `${window.location.origin}${ROUTE_B2B_EA}`;
    // if (window.location.origin.includes('sogys.local.com')) {
    //     // ici on a un petit tricks uniquement en local, derrière le nginx !
    //     // on redirige vers le b2b en ajoutant le /pro devant le path.
    //     // ca va faire un /pro/pro, avant que vite ne comprenne ce qui se passe.
    //     // Il va charger correctement le /pro/pro, puis après il retrouve ses petits,
    //     // ensuite toutes les routes seront gérées par vite, et le double pro disparaitra !
    //     // Vite n'est pas utilisé en dev, preprod, prod (sauf pour le build, ou il lui faut le /pro)
    //     redirectUrl = `${window.location.origin}/pro${ROUTE_B2B_EA}`;
    // }
    window.location.href = redirectUrl;
};
